<template>
  <el-upload
    class="avatar-uploader"
    action="https://jsonplaceholder.typicode.com/posts/"
    :show-file-list="false"
    :http-request="uploadImage"
    v-loading="loading"
  >
    <img v-if="imageUrl" :src="imageUrl" class="avatar" style="object-fit: contain;" />
    <span v-else class="avatar-uploader-icon">{{label}}</span>
  </el-upload>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '+'
    },
    imgType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageUrl: "",
      loading: false
    }
  },
  mounted() {
    this.imageUrl = this.value
  },
  methods: {
    uploadImage(data) {
      this.loading = true;
      let imgFile = new FileReader();
      let imageBase64 = ''
      imgFile.readAsDataURL(data.file);

      imgFile.onload = (e) => {
        imageBase64 = e.target.result; //base64数据
        // let newImageBase64 = imageBase64.replace(/data:image\/jpeg;base64,/, "").replace(/data:image\/png;base64,/, "").replace(/data:image\/jpg;base64,/, "").replace(/data:image\/gif;base64,/, "");
        this.imageUrl = imageBase64;
        this.$emit('input', imageBase64)
        this.loading = false;
        // this.$api.firmCustDataUpload({
        //   "imageBase64": newImageBase64,
        //   "imgType": this.imgType
        // }).then(res => {
        //   if (res.data.success) {
        //     console.log(res.data.data)
        //     this.imageUrl = res.data.data;
        //     this.$emit('input', res.data.data)
        //   }
        // }).finally(_ => {
        //   this.loading = false;
        // })
      }
    }
  }
}
</script>

<style lang='less' scoped>
@import '../../../style/mixin.less';
.lable {
  font-size: 20px;
  color: #e0e0e0;
}
.image-upload{
  height: 100%;
  width: 100%;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed rgba(153, 153, 153, 0.36);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
/deep/.el-upload {
  width: 100%;
  height: 100%;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
  height: 100%;
}
/deep/.avatar-uploader-icon {
  display: block;
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  text-align: center;
  border-radius: 6px;
  border: 1px dashed rgba(153, 153, 153, 0.36);
  .flex(center);
}
/deep/.avatar {
  width: 100%;
  height: 100%;
  display: block;
  border: 1px dashed rgba(153, 153, 153, 0.36);
  border-radius: 6px;
  overflow: hidden;
}
</style>